export function formatFileSize(bytes, precision = 0) {
  if (bytes < 1048576) {
    return (bytes / 1024).toFixed(precision) + " KB"
  } else {
    return (bytes / 1048576).toFixed(precision) + " MB"
  }
}
